import { useMutation } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IGetCitiesResponseType } from './type'
import { IResponseType } from '@/types/response-type'
import { IPaginatedResponse } from '../category/type'

export function useGetCities({
  disableToast,
  ...rest
}: IApiBaseTypes<{}> = {}) {
  return useMutation({
    mutationFn: async (pId: number) =>
      await APIInstance<IGetCitiesResponseType[]>({
        url: `mrf/cities/?province=${pId}`,
        method: 'get'
      }),
    retry: 0,
    mutationKey: ['citiesItem'],
    ...rest
  })
}
